import type { Ref } from 'vue'

import type { PublicMainMenu } from '@/service/__generated-api'

type HeaderSettings = Pick<PublicMainMenu, 'items'>

// Ref.: https://v3.nuxtjs.org/guide/features/state-management/
export const useHeaderSettings = async (): Promise<
  Ref<HeaderSettings | null>
> => {
  const settings = useState<HeaderSettings | null>(
    'header-settings',
    () => null
  )

  if (!settings.value) {
    settings.value = await useApi().publicMenuMainRetrieve({
      fetchKeys: { items: true }
    })
  }

  return settings
}
